import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import Layout from "@/layout/layout";

const routes = [
  {
    path: "/",
    redirect: "/init-page",
    component: Layout,
    meta: {
      title: "活动平台",
    },
    children: [
      {
        name: "Home",
        path: "home",
        component: () => import("@/pages/home/home"),
        meta: {
          title: "首页",
          deepth: 10,
        },
      },
      {
        name: "Scan",
        path: "scan",
        component: () => import("@/pages/scan/scan"),
        meta: {
          title: "扫码",
        },
      },
      {
        name: "My",
        path: "my",
        component: () => import("@/pages/my/my"),
        meta: {
          title: "我的",
        },
      },
    ],
  },
  {
    name: "Init",
    path: "/init-page",
    meta: {
      title: "活动平台",
    },
    component: () => import("@/pages/init-page/init-page"),
  },
  {
    name: "Binding",
    path: "/binding",
    meta: {
      title: "绑定手机号",
    },
    component: () => import("@/pages/binding/binding"),
  },
  {
    name: "appletLogin",
    path: "/applet-login",
    meta: {
      title: "打开小程序",
    },
    component: () => import("@/pages/open-applet/login"),
  },
  {
    name: "playPage",
    path: "/play-page",
    meta: {
      title: "支付页",
    },
    component: () => import("@/pages/open-applet/play-page"),
  },
  {
    name: "RoleChange",
    path: "/role-change",
    meta: {
      title: "选择角色",
    },
    component: () => import("@/pages/role-change/role-change"),
  },
  {
    name: "TemplateList",
    path: "/template",
    meta: {
      title: "活动模板",
      deepth: 10,
    },
    component: () => import("@/pages/activity-templates/activity-templates"),
  },
  {
    name: "CreateActivity",
    path: "/activity/create",
    component: () => import("@/pages/activity-management/create-activity"),
    meta: {
      title: "创建活动",
      keepAlive: true,
      deepth: 20,
    },
  },
  {
    name: "newCreateActivity",
    path: "/newActivity/create",
    component: () => import("@/pages/activity-management/new-create-activity/home"),
    meta: {
      title: "创建活动",
      keepAlive: true,
      deepth: 20,
    },
  },
  {
    name: "EditActivity",
    path: "/activity/edit",
    component: () => import("@/pages/activity-management/edit-activity"),
    meta: {
      title: "编辑",
    },
  },
  {
    name: "EditActivityBasic",
    path: "/activity/edit-basic",
    component: () => import("@/pages/activity-management/edit-activity-basic"),
    meta: {
      title: "编辑",
    },
  },
  {
    name: "ActivityPoster",
    path: "/activity/poster",
    component: () => import("@/pages/activity-management/activity-poster"),
    meta: {
      title: "海报设置",
    },
  },
  {
    name: "PromotionPoster",
    path: "/activity/promotion-poster",
    component: () => import("@/pages/activity-management/promotion-poster"),
    meta: {
      title: "海报分享",
    },
  },
  {
    name: "AdditionalActivity",
    path: "/activity/additional",
    component: () => import("@/pages/activity-management/additional-activity"),
    meta: {
      title: "附加活动",
    },
  },
  {
    name: "RechargeRecords",
    path: "/recharge-records",
    component: () => import("@/pages/activity-management/recharge-records"),
    meta: {
      title: "充值记录",
    },
  },
  {
    name: 'usageRecord',
    path: '/usage-record',
    component: () => import('@/pages/activity-management/usage-record'),
    meta: {
      title: '使用记录'
    }
  },
  {
    name: 'ActivityHome',
    path: '/activity-home',
    component: () => import('@/pages/activity-home/activity-home'),
    meta: {
      title: "活动首页",
      deepth: 30,
    },
  },
  {
    name: "VerifySignUp",
    path: "/verify",
    component: () => import("@/pages/scan/verify-sign-up"),
    meta: {
      title: "核销",
    },
  },
  {
    name: "ManagerList",
    path: "/manager-list",
    component: () => import("@/pages/manager-config/manager-list"),
    meta: {
      title: "活动管理员",
    },
  },
  {
    name: "Drafts",
    path: "/drafts",
    component: () => import("@/pages/drafts/drafts"),
    meta: {
      title: "草稿箱",
    },
  },
  {
    name: "ActivityData",
    path: "/activity-data",
    component: () => import("@/pages/activity-data/activity-data"),
    meta: {
      title: "活动数据",
    },
  },
  {
    name: "CustomerList",
    path: "/customer-list",
    component: () => import("@/pages/customer-list/customer-list"),
    meta: {
      title: "客户列表",
    },
  },
  {
    name: "couponList",
    path: "/coupon-list",
    component: () => import("@/pages/component-list/coupon-list"), 
    meta: {
      title: "优惠券列表",
    },
  },
  {
    name: "lotteryList",
    path: "/lottery-list",
    component: () => import("@/pages/component-list/lottery-list"), 
    meta: {
      title: "抽奖奖品列表",
    },
  },
  {
    name: "groupList",
    path: "/group-list",
    component: () => import("@/pages/component-list/group-list"), 
    meta: {
      title: "拼团数据",
    },
  },
  {
    name: "spikeList",
    path: "/spike-list",
    component: () => import("@/pages/component-list/spike-list"), 
    meta: {
      title: "秒杀数据",
    },
  },
  {
    name: "drawLotsList",
    path: "/drawLots-list",
    component: () => import("@/pages/component-list/drawLots-list"), 
    meta: {
      title: "抽签数据",
    },
  },
  {
    name: "questionList",
    path: "/question-list",
    component: () => import("@/pages/component-list/question-list"), 
    meta: {
      title: "问答数据",
    },
  },
  {
    name: "countMoneyList",
    path: "/countMoney-list",
    component: () => import("@/pages/component-list/countMoney-list"), 
    meta: {
      title: "红包挑战赛数据",
    },
  },
  {
    name: "countMoneyInfo",
    path: "/countMoney-info",
    component: () => import("@/pages/component-list/countMoney-info"), 
    meta: {
      title: "奖品信息",
    },
  },
  {
    name: "rejectRefund",
    path: "/reject-refund",
    component: () => import("@/pages/customer-list/reject-refund"),
    meta: {
      title: "拒绝退款",
    },
  },
  {
    name: "refundVoucher",
    path: "/refund-voucher",
    component: () => import("@/pages/customer-list/refund-voucher"),
    meta: {
      title: "上传退款凭证",
    },
  },
  {
    name: "WithdrawalHome",
    path: "/withdrawal-home",
    component: () => import("@/pages/withdrawal/home"),
    meta: {
      title: "微信钱包提现",
    },
  },
  {
    name: "Withdrawal",
    path: "/withdrawal",
    component: () => import("@/pages/withdrawal/withdrawal"),
    meta: {
      title: "提现",
    },
  },
  {
    name: "Withdrawal",
    path: "/record",
    component: () => import("@/pages/withdrawal/record"),
    meta: {
      title: "记录",
    },
  },
  {
    name: "unionpayBalance",
    path: "/unionpay-balance",
    component: () => import("@/pages/unionpay-withdrawal/unionpay-balance"),
    meta: {
      title: "银联商户号提现",
    },
  },
  {
    name: "capitalChecking",
    path: "/capital-checking",
    component: () => import("@/pages/capital-checking/index"),
    meta: {
      title: "资金对账",
    },
  },
  {
    name: "unionpayWithdrawal",
    path: "/unionpay-withdrawal",
    component: () => import("@/pages/unionpay-withdrawal/unionpay-withdrawal"),
    meta: {
      title: "提现",
    },
  },
  {
    name: "Dealer",
    path: "/dealer",
    component: () => import("@/pages/dealer/dealer"),
    meta: {
      title: "经销商",
    },
  },
  {
    name: "dataDownload",
    path: "/data-download",
    component: () => import("@/pages/data-download/data-download"),
    meta: {
      title: "数据下载",
    },
  },
  {
    name: "exportList",
    path: "/export-list",
    component: () => import("@/pages/data-download/export-list"),
    meta: {
      title: "导出列表",
    },
  },
  {
    name: "account",
    path: "/account",
    component: () => import("@/pages/withdrawal-setting/account"),
    meta: {
      title: "提现/入网签约设置",
    },
  },
  {
    name: "accountSet",
    path: "/account-set",
    component: () => import("@/pages/withdrawal-setting/account-set"),
    meta: {
      title: "账号设置",
    },
  },
  {
    name: "capitalDetail",
    path: "/capitalDetail",
    component: () => import("@/pages/capital-detail/capital-detail"),
    meta: {
      title: "商户号资金明细",
    },
  },
  {
    name: 'Store',
    path: '/store',
    component: () => import('@/pages/store/store'),
    meta: {
      title: '门店'
    }
  },
  {
    name: "Stuff",
    path: "/stuff",
    component: () => import("@/pages/stuff/stuff"),
    meta: {
      title: "职员",
    },
  },
  {
    name: "User",
    path: "/user",
    component: () => import("@/pages/user/user"),
    meta: {
      title: "用户",
    },
  },
  {
    name: "ActivetyManager",
    path: "/activety-manager",
    component: () => import("@/pages/activety-manager/activety-manager"),
    meta: {
      title: "活动管理",
    },
  },
  {
    name: "TaskDetails",
    path: "/task-details",
    component: () => import("@/pages/task-details/task-details"),
    meta: {
      title: "任务详情",
    },
  },
  {
    name: "winningClue",
    path: "/winning-clue",
    component: () => import("@/pages/winning-clue/winning-clue"),
    meta: {
      title: "中奖线索",
    },
  },
  {
    name: "runBook",
    path: "/runBook",
    component: () => import("@/pages/help/index"),
    meta: {
      title: "操作手册",
    },
  },
  {
    name: "helpVideo",
    path: "/help-video",
    component: () => import("@/pages/help/video"),
    meta: {
      title: "视屏",
    },
  },
  {
    name: "helpFile",
    path: "/help-file",
    component: () => import("@/pages/help/file"),
    meta: {
      title: "文件",
    },
  },
  {
    name: "lotteryConfig",
    path: "/lottery-config",
    component: () => import("@/pages/lottery-config/lottery-config"),
    meta: {
      title: "抽奖设置",
    },
  },
  {
    name: "activityRecharge",
    path: "/activity-recharge",
    component: () => import("@/pages/activity-recharge/activity-recharge"),
    meta: {
      title: "活动充值",
      keepAlive: true
    },
  },
  {
    name: "questionCreate",
    path: "/question-create",
    component: () => import("@/pages/question/question-create"),
    meta: {
      title: "创建试题",
      keepAlive: true
    },
  },
  {
    name: "answer",
    path: "/answer",
    component: () => import("@/pages/question/answer"),
    meta: {
      title: "问答过程页面",
      keepAlive: true
    },
  },
  {
    name: "spikeList",
    path: "/spike-list",
    component: () => import("@/pages/spike/spike-list"),
    meta: {
      title: "秒杀专区",
    },
  },
  {
    name: "spikeDetail",
    path: "/spike-detail",
    component: () => import("@/pages/spike/spike-detail"),
    meta: {
      title: "商品详情",
    }
  },
  {
    name: "connectPic",
    path: "/connect-pic",
    component: () => import("@/pages/connect-pic/index"),
    meta: {
      title: "拼图过程页面"
    },
  },
  {
    name: "groupDetail",
    path: "/group-detail",
    component: () => import("@/pages/group-buy/group-detail"),
    meta: {
      title: "商品详情"
    },
  },
  {
    name: "video",
    path: "/video",
    component: () => import("@/pages/no-login/video"),
    meta: {
      title: "视频"
    },
  },
  {
    name: "styleTest",
    path: "/styleTest",
    component: () => import("@/pages/no-login/style-test"),
    meta: {
      title: "风格测试"
    },
  },
  {
    path: "*",
    redirect: "/init-page",
  },
];

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: [...routes],
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
